module.exports = __webpack_public_path__ + "media/images/emblems/Herzogenbuchsee-coat_of_arms-85fb214fa9db2b37401744af2bfe79b8.svg";